import Login from './Login';
import CohortTooltipText from './CohortTooltipText';

const COMMON ={
    ...Login,
    ...CohortTooltipText,
}

export default COMMON;